// import { useEffect, useMemo, useState } from "react";
// import {
//   collection,
//   query,
//   orderBy,
//   startAt,
//   endAt,
//   limit,
//   getDocs,
//   addDoc,
//   serverTimestamp,
// } from "firebase/firestore";
// import { db } from "../../firebase";

// const NP_API_URL = "https://api.novaposhta.ua/v2.0/json/";

// function normalizePhone(s = "") {
//   return String(s).replace(/\D/g, "");
// }

// export default function BusinessAddressesManager({ uid, novaPoshtaKey }) {
//   const [search, setSearch] = useState("");
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // форма додавання
//   const [fio, setFio] = useState("");
//   const [phone, setPhone] = useState("");
//   const [cityInput, setCityInput] = useState("");
//   const [cityChoice, setCityChoice] = useState(null);
//   const [citiesList, setCitiesList] = useState([]);
//   const [deptChoice, setDeptChoice] = useState(null);
//   const [deptsList, setDeptsList] = useState([]);

//   const canSearch = useMemo(() => search.trim().length >= 1, [search]);

//   const fetchAddresses = async () => {
//     if (!uid) return;
//     setLoading(true);
//     const ref = collection(db, `users/${uid}/deliveryAddresses`);
//     const term = search.trim().toLowerCase();

//     try {
//       let qList = [];
//       if (term) {
//         // 3 окремі префіксні пошуки — по ПІБ, телефону (цифри), місту
//         const qByFio = query(
//           ref,
//           orderBy("fioLC"),
//           startAt(term),
//           endAt(term + "\uf8ff"),
//           limit(20),
//         );
//         const qByPhone = query(
//           ref,
//           orderBy("phoneNorm"),
//           startAt(normalizePhone(term)),
//           endAt(normalizePhone(term) + "\uf8ff"),
//           limit(20),
//         );
//         const qByCity = query(
//           ref,
//           orderBy("cityLC"),
//           startAt(term),
//           endAt(term + "\uf8ff"),
//           limit(20),
//         );
//         qList = [qByFio, qByPhone, qByCity];
//       } else {
//         // без фільтра — перші 20 для швидкого старту
//         qList = [query(ref, orderBy("createdAt", "desc"), limit(20))];
//       }

//       const all = [];
//       for (const qx of qList) {
//         const snap = await getDocs(qx);
//         snap.forEach((d) => all.push({ id: d.id, ...d.data() }));
//       }
//       // де-дуп
//       const dedup = Object.values(
//         all.reduce((acc, r) => {
//           acc[r.id] = r;
//           return acc;
//         }, {}),
//       );
//       setRows(dedup);
//     } catch (e) {
//       console.error("Помилка пошуку адрес:", e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAddresses();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [uid]);

//   useEffect(() => {
//     const id = setTimeout(fetchAddresses, 300);
//     return () => clearTimeout(id);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [search]);

//   // ---- НП: пошук міст ----
//   const onCityInput = async (val) => {
//     setCityInput(val);
//     setCityChoice(null);
//     setDeptsList([]);
//     setDeptChoice(null);
//     if (!novaPoshtaKey || !val.trim()) return setCitiesList([]);

//     try {
//       const body = {
//         apiKey: novaPoshtaKey,
//         modelName: "Address",
//         calledMethod: "getCities",
//         methodProperties: { FindByString: val },
//       };
//       const res = await fetch(NP_API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(body),
//       });
//       const data = await res.json();
//       setCitiesList(Array.isArray(data?.data) ? data.data : []);
//     } catch (e) {
//       console.error("НП: помилка getCities", e);
//     }
//   };

//   // ---- НП: відділення ----
//   const loadDepts = async (cityRef) => {
//     if (!novaPoshtaKey || !cityRef) return setDeptsList([]);
//     try {
//       const body = {
//         apiKey: novaPoshtaKey,
//         modelName: "AddressGeneral",
//         calledMethod: "getWarehouses",
//         methodProperties: { CityRef: cityRef, Page: "1", Limit: "500" },
//       };
//       const res = await fetch(NP_API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(body),
//       });
//       const data = await res.json();
//       setDeptsList(Array.isArray(data?.data) ? data.data : []);
//     } catch (e) {
//       console.error("НП: помилка getWarehouses", e);
//       setDeptsList([]);
//     }
//   };

//   const onPickCity = async (city) => {
//     setCityChoice(city);
//     setCityInput(city?.Description || "");
//     setCitiesList([]);
//     await loadDepts(city?.Ref);
//   };

//   const onSaveAddress = async () => {
//     if (!uid) return;
//     const fioTrim = fio.trim();
//     const phoneNorm = normalizePhone(phone);
//     const dept = deptChoice?.Description || "";
//     const cityName = cityChoice?.Description || cityInput.trim();
//     const area = cityChoice?.AreaDescription || "";
//     if (!fioTrim || !phoneNorm || !cityName || !dept)
//       return alert("Заповніть ПІБ, телефон, місто і відділення НП.");

//     try {
//       const ref = collection(db, `users/${uid}/deliveryAddresses`);
//       const payload = {
//         fio: fioTrim,
//         phone: phoneNorm,
//         city: cityName,
//         area,
//         npWarehouse: dept,
//         cityRef: cityChoice?.Ref || null,
//         warehouseRef: deptChoice?.Ref || null,

//         // поля для пошуку
//         fioLC: fioTrim.toLowerCase(),
//         phoneNorm,
//         cityLC: cityName.toLowerCase(),

//         createdAt: serverTimestamp(),
//       };
//       await addDoc(ref, payload);
//       // очистити форму та оновити список
//       setFio("");
//       setPhone("");
//       setCityInput("");
//       setCityChoice(null);
//       setDeptChoice(null);
//       setDeptsList([]);
//       await fetchAddresses();
//     } catch (e) {
//       console.error("Помилка збереження адреси:", e);
//       alert("Не вдалося зберегти адресу. Спробуйте ще раз.");
//     }
//   };

//   return (
//     <div style={{ display: "grid", gap: 12 }}>
//       {/* Пошук існуючих адрес */}
//       <div style={{ display: "grid", gap: 8 }}>
//         <label style={{ fontWeight: 600 }}>
//           Пошук адреси (ПІБ / телефон / населений пункт)
//         </label>
//         <input
//           type="text"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           placeholder="Почніть вводити..."
//           style={{ padding: 10, border: "1px solid #ddd", borderRadius: 8 }}
//         />
//         {loading ? (
//           <div>Завантаження…</div>
//         ) : (
//           <div
//             style={{
//               maxHeight: 260,
//               overflow: "auto",
//               border: "1px solid #eee",
//               borderRadius: 8,
//             }}
//           >
//             {rows.length === 0 ? (
//               <div style={{ padding: 10, color: "#777" }}>
//                 Нічого не знайдено
//               </div>
//             ) : (
//               <table style={{ width: "100%", fontSize: 14 }}>
//                 <thead>
//                   <tr style={{ textAlign: "left", background: "#fafafa" }}>
//                     <th style={{ padding: 8 }}>ПІБ</th>
//                     <th style={{ padding: 8 }}>Телефон</th>
//                     <th style={{ padding: 8 }}>Населений пункт / Область</th>
//                     <th style={{ padding: 8 }}>Відділення НП</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {rows.map((r) => (
//                     <tr key={r.id}>
//                       <td style={{ padding: 8 }}>{r.fio}</td>
//                       <td style={{ padding: 8 }}>{r.phone}</td>
//                       <td style={{ padding: 8 }}>
//                         {r.city}
//                         {r.area ? `, ${r.area}` : ""}
//                       </td>
//                       <td style={{ padding: 8 }}>{r.npWarehouse}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Додавання нової адреси */}
//       <div
//         style={{
//           marginTop: 8,
//           paddingTop: 8,
//           borderTop: "1px dashed #ddd",
//           display: "grid",
//           gap: 8,
//         }}
//       >
//         <div
//           style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}
//         >
//           <div style={{ display: "grid", gap: 6 }}>
//             <label style={{ fontWeight: 600 }}>ПІБ отримувача</label>
//             <input
//               type="text"
//               value={fio}
//               onChange={(e) => setFio(e.target.value)}
//               style={{ padding: 10, border: "1px solid #ddd", borderRadius: 8 }}
//             />
//           </div>
//           <div style={{ display: "grid", gap: 6 }}>
//             <label style={{ fontWeight: 600 }}>Телефон отримувача</label>
//             <input
//               type="tel"
//               value={phone}
//               onChange={(e) => setPhone(e.target.value)}
//               placeholder="380..."
//               style={{ padding: 10, border: "1px solid #ddd", borderRadius: 8 }}
//             />
//           </div>
//         </div>

//         <div style={{ display: "grid", gap: 6 }}>
//           <label style={{ fontWeight: 600 }}>Місто (НП)</label>
//           <input
//             type="text"
//             value={cityInput}
//             onChange={(e) => onCityInput(e.target.value)}
//             placeholder="Почніть вводити місто..."
//             style={{ padding: 10, border: "1px solid #ddd", borderRadius: 8 }}
//           />
//           {Array.isArray(citiesList) && citiesList.length > 0 && (
//             <div
//               style={{
//                 maxHeight: 180,
//                 overflow: "auto",
//                 border: "1px solid #eee",
//                 borderRadius: 8,
//               }}
//             >
//               {citiesList.map((c) => (
//                 <div
//                   key={c.Ref}
//                   onClick={() => onPickCity(c)}
//                   style={{ padding: 8, cursor: "pointer" }}
//                 >
//                   {c.SettlementTypeDescription}, {c.Description},{" "}
//                   {c.AreaDescription}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         <div style={{ display: "grid", gap: 6 }}>
//           <label style={{ fontWeight: 600 }}>Відділення НП</label>
//           <select
//             value={deptChoice?.Ref || ""}
//             onChange={(e) => {
//               const ref = e.target.value;
//               const obj = deptsList.find((d) => d.Ref === ref) || null;
//               setDeptChoice(obj);
//             }}
//             disabled={!cityChoice?.Ref}
//             style={{ padding: 10, border: "1px solid #ddd", borderRadius: 8 }}
//           >
//             <option value="">Оберіть відділення</option>
//             {deptsList.map((d) => (
//               <option key={d.Ref} value={d.Ref}>
//                 {d.Description}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div>
//           <button
//             onClick={onSaveAddress}
//             style={{
//               padding: "10px 14px",
//               borderRadius: 8,
//               background: "#3e51c1",
//               color: "#fff",
//               border: 0,
//             }}
//           >
//             Додати адресу
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }
import { useEffect, useRef, useState } from "react";
import {
  collection,
  query,
  orderBy,
  startAt,
  endAt,
  limit,
  getDocs,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase";

const NP_API_URL = "https://api.novaposhta.ua/v2.0/json/";

function normalizePhone(s = "") {
  return String(s).replace(/\D/g, "");
}

export default function BusinessAddressesManager({ uid, novaPoshtaKey }) {
  const cityBoxRef = useRef(null);
  const deptBoxRef = useRef(null);

  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [fio, setFio] = useState("");
  const [phone, setPhone] = useState("");

  const [cityInput, setCityInput] = useState("");
  const [cityChoice, setCityChoice] = useState(null);
  const [citiesList, setCitiesList] = useState([]);
  const [cityDropdownVisible, setCityDropdownVisible] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);

  const [deptInput, setDeptInput] = useState("");
  const [deptChoice, setDeptChoice] = useState(null);
  const [deptsList, setDeptsList] = useState([]);
  const [deptDropdownVisible, setDeptDropdownVisible] = useState(false);
  const [loadingDepts, setLoadingDepts] = useState(false);

  const fetchAddresses = async () => {
    if (!uid) return;

    setLoading(true);
    const ref = collection(db, `users/${uid}/deliveryAddresses`);
    const term = search.trim().toLowerCase();

    try {
      let qList = [];

      if (term) {
        const qByFio = query(
          ref,
          orderBy("fioLC"),
          startAt(term),
          endAt(term + "\uf8ff"),
          limit(20),
        );

        const qByPhone = query(
          ref,
          orderBy("phoneNorm"),
          startAt(normalizePhone(term)),
          endAt(normalizePhone(term) + "\uf8ff"),
          limit(20),
        );

        const qByCity = query(
          ref,
          orderBy("cityLC"),
          startAt(term),
          endAt(term + "\uf8ff"),
          limit(20),
        );

        qList = [qByFio, qByPhone, qByCity];
      } else {
        qList = [query(ref, orderBy("createdAt", "desc"), limit(20))];
      }

      const all = [];
      for (const qx of qList) {
        const snap = await getDocs(qx);
        snap.forEach((d) => all.push({ id: d.id, ...d.data() }));
      }

      const dedup = Object.values(
        all.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {}),
      );

      setRows(dedup);
    } catch (e) {
      console.error("Помилка пошуку адрес:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, [uid]);

  useEffect(() => {
    const id = setTimeout(fetchAddresses, 300);
    return () => clearTimeout(id);
  }, [search]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (cityBoxRef.current && !cityBoxRef.current.contains(event.target)) {
        setCityDropdownVisible(false);
      }

      if (deptBoxRef.current && !deptBoxRef.current.contains(event.target)) {
        setDeptDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const searchCities = async (val) => {
    if (!novaPoshtaKey || !val.trim()) {
      setCitiesList([]);
      return;
    }

    try {
      setLoadingCities(true);

      const body = {
        apiKey: novaPoshtaKey,
        modelName: "Address",
        calledMethod: "getCities",
        methodProperties: { FindByString: val },
      };

      const res = await fetch(NP_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await res.json();
      setCitiesList(Array.isArray(data?.data) ? data.data : []);
    } catch (e) {
      console.error("НП: помилка getCities", e);
      setCitiesList([]);
    } finally {
      setLoadingCities(false);
    }
  };

  const searchDepartments = async (cityRef, val = "") => {
    if (!novaPoshtaKey || !cityRef) {
      setDeptsList([]);
      return;
    }

    try {
      setLoadingDepts(true);

      const body = {
        apiKey: novaPoshtaKey,
        modelName: "AddressGeneral",
        calledMethod: "getWarehouses",
        methodProperties: {
          CityRef: cityRef,
          FindByString: val.trim(),
          Page: "1",
          Limit: "200",
        },
      };

      const res = await fetch(NP_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await res.json();
      setDeptsList(Array.isArray(data?.data) ? data.data : []);
    } catch (e) {
      console.error("НП: помилка getWarehouses", e);
      setDeptsList([]);
    } finally {
      setLoadingDepts(false);
    }
  };

  const onCityInput = async (val) => {
    setCityInput(val);
    setCityChoice(null);
    setCityDropdownVisible(true);

    setDeptInput("");
    setDeptChoice(null);
    setDeptsList([]);
    setDeptDropdownVisible(false);

    await searchCities(val);
  };

  const onPickCity = async (city) => {
    setCityChoice(city);
    setCityInput(city?.Description || "");
    setCitiesList([]);
    setCityDropdownVisible(false);

    setDeptInput("");
    setDeptChoice(null);
    setDeptsList([]);

    await searchDepartments(city?.Ref, "");
  };

  const onDeptInput = async (val) => {
    setDeptInput(val);
    setDeptChoice(null);
    setDeptDropdownVisible(true);

    if (!cityChoice?.Ref) {
      setDeptsList([]);
      return;
    }

    await searchDepartments(cityChoice.Ref, val);
  };

  const onPickDept = (dept) => {
    setDeptChoice(dept);
    setDeptInput(dept?.Description || "");
    setDeptDropdownVisible(false);
  };

  const onSaveAddress = async () => {
    if (!uid) return;

    const fioTrim = fio.trim();
    const phoneNorm = normalizePhone(phone);
    const dept = deptChoice?.Description || deptInput.trim();
    const cityName = cityChoice?.Description || cityInput.trim();
    const area = cityChoice?.AreaDescription || "";

    if (!fioTrim || !phoneNorm || !cityName || !dept) {
      alert("Заповніть ПІБ, телефон, місто і відділення НП.");
      return;
    }

    try {
      const ref = collection(db, `users/${uid}/deliveryAddresses`);

      const payload = {
        fio: fioTrim,
        phone: phoneNorm,
        city: cityName,
        area,
        npWarehouse: dept,
        cityRef: cityChoice?.Ref || null,
        warehouseRef: deptChoice?.Ref || null,
        fioLC: fioTrim.toLowerCase(),
        phoneNorm,
        cityLC: cityName.toLowerCase(),
        createdAt: serverTimestamp(),
      };

      await addDoc(ref, payload);

      setFio("");
      setPhone("");
      setCityInput("");
      setCityChoice(null);
      setCitiesList([]);
      setDeptInput("");
      setDeptChoice(null);
      setDeptsList([]);
      setCityDropdownVisible(false);
      setDeptDropdownVisible(false);

      await fetchAddresses();
    } catch (e) {
      console.error("Помилка збереження адреси:", e);
      alert("Не вдалося зберегти адресу. Спробуйте ще раз.");
    }
  };

  return (
    <div style={{ display: "grid", gap: 12 }}>
      <div style={{ display: "grid", gap: 8 }}>
        <label style={{ fontWeight: 600 }}>
          Пошук адреси (ПІБ / телефон / населений пункт)
        </label>

        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Почніть вводити..."
          style={{ padding: 10, border: "1px solid #ddd", borderRadius: 8 }}
        />

        {loading ? (
          <div>Завантаження...</div>
        ) : (
          <div
            style={{
              maxHeight: 260,
              overflow: "auto",
              border: "1px solid #eee",
              borderRadius: 8,
            }}
          >
            {rows.length === 0 ? (
              <div style={{ padding: 10, color: "#777" }}>
                Нічого не знайдено
              </div>
            ) : (
              <table style={{ width: "100%", fontSize: 14 }}>
                <thead>
                  <tr style={{ textAlign: "left", background: "#fafafa" }}>
                    <th style={{ padding: 8 }}>ПІБ</th>
                    <th style={{ padding: 8 }}>Телефон</th>
                    <th style={{ padding: 8 }}>Населений пункт / Область</th>
                    <th style={{ padding: 8 }}>Відділення НП</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r.id}>
                      <td style={{ padding: 8 }}>{r.fio}</td>
                      <td style={{ padding: 8 }}>{r.phone}</td>
                      <td style={{ padding: 8 }}>
                        {r.city}
                        {r.area ? `, ${r.area}` : ""}
                      </td>
                      <td style={{ padding: 8 }}>{r.npWarehouse}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>

      <div
        style={{
          marginTop: 8,
          paddingTop: 8,
          borderTop: "1px dashed #ddd",
          display: "grid",
          gap: 8,
        }}
      >
        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}
        >
          <div style={{ display: "grid", gap: 6 }}>
            <label style={{ fontWeight: 600 }}>ПІБ отримувача</label>
            <input
              type="text"
              value={fio}
              onChange={(e) => setFio(e.target.value)}
              style={{ padding: 10, border: "1px solid #ddd", borderRadius: 8 }}
            />
          </div>

          <div style={{ display: "grid", gap: 6 }}>
            <label style={{ fontWeight: 600 }}>Телефон отримувача</label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="380..."
              style={{ padding: 10, border: "1px solid #ddd", borderRadius: 8 }}
            />
          </div>
        </div>

        <div
          ref={cityBoxRef}
          style={{ display: "grid", gap: 6, position: "relative" }}
        >
          <label style={{ fontWeight: 600 }}>Місто (НП)</label>
          <input
            type="text"
            value={cityInput}
            onChange={(e) => onCityInput(e.target.value)}
            onFocus={() => setCityDropdownVisible(true)}
            placeholder="Почніть вводити місто..."
            style={{ padding: 10, border: "1px solid #ddd", borderRadius: 8 }}
          />

          {cityDropdownVisible && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                marginTop: 4,
                maxHeight: 220,
                overflow: "auto",
                border: "1px solid #eee",
                borderRadius: 8,
                background: "#fff",
                zIndex: 20,
              }}
            >
              {loadingCities ? (
                <div style={{ padding: 8 }}>Завантаження...</div>
              ) : citiesList.length > 0 ? (
                citiesList.map((c) => (
                  <div
                    key={c.Ref}
                    onClick={() => onPickCity(c)}
                    style={{ padding: 8, cursor: "pointer" }}
                  >
                    {c.SettlementTypeDescription}, {c.Description},{" "}
                    {c.AreaDescription}
                  </div>
                ))
              ) : cityInput.trim() ? (
                <div style={{ padding: 8, color: "#777" }}>
                  Місто не знайдено
                </div>
              ) : null}
            </div>
          )}
        </div>

        <div
          ref={deptBoxRef}
          style={{ display: "grid", gap: 6, position: "relative" }}
        >
          <label style={{ fontWeight: 600 }}>Відділення НП</label>
          <input
            type="text"
            value={deptInput}
            onChange={(e) => onDeptInput(e.target.value)}
            onFocus={() => {
              if (cityChoice?.Ref) {
                setDeptDropdownVisible(true);
                if (deptsList.length === 0) {
                  searchDepartments(cityChoice.Ref, deptInput);
                }
              }
            }}
            placeholder={
              cityChoice?.Ref
                ? "Введіть номер або назву відділення"
                : "Спочатку оберіть місто"
            }
            disabled={!cityChoice?.Ref}
            style={{ padding: 10, border: "1px solid #ddd", borderRadius: 8 }}
          />

          {deptDropdownVisible && cityChoice?.Ref && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                marginTop: 4,
                maxHeight: 240,
                overflow: "auto",
                border: "1px solid #eee",
                borderRadius: 8,
                background: "#fff",
                zIndex: 20,
              }}
            >
              {loadingDepts ? (
                <div style={{ padding: 8 }}>Завантаження...</div>
              ) : deptsList.length > 0 ? (
                deptsList.map((d) => (
                  <div
                    key={d.Ref}
                    onClick={() => onPickDept(d)}
                    style={{ padding: 8, cursor: "pointer" }}
                  >
                    {d.Description}
                  </div>
                ))
              ) : (
                <div style={{ padding: 8, color: "#777" }}>
                  Відділень не знайдено
                </div>
              )}
            </div>
          )}
        </div>

        <div>
          <button
            onClick={onSaveAddress}
            style={{
              padding: "10px 14px",
              borderRadius: 8,
              background: "#3e51c1",
              color: "#fff",
              border: 0,
              cursor: "pointer",
            }}
          >
            Додати адресу
          </button>
        </div>
      </div>
    </div>
  );
}
